import { useEffect } from 'react';
import './ErrorToast.css';

export interface ErrorToastProps {
  message: string;
  type?: 'error' | 'warning' | 'info';
  onClose: () => void;
  autoClose?: boolean;
  autoCloseDelay?: number;
  actionLabel?: string;
  onAction?: () => void;
}

export const ErrorToast = ({
  message,
  type = 'error',
  onClose,
  autoClose = true,
  autoCloseDelay = 5000,
  actionLabel,
  onAction,
}: ErrorToastProps) => {
  useEffect(() => {
    if (autoClose) {
      const timer = setTimeout(() => {
        onClose();
      }, autoCloseDelay);

      return () => clearTimeout(timer);
    }
  }, [autoClose, autoCloseDelay, onClose]);

  const getIcon = () => {
    switch (type) {
      case 'error':
        return '✕';
      case 'warning':
        return '⚠';
      case 'info':
        return 'ℹ';
      default:
        return '✕';
    }
  };

  return (
    <div className={`error-toast error-toast--${type}`} role="alert">
      <div className="error-toast__icon">{getIcon()}</div>
      <div className="error-toast__content">
        <p className="error-toast__message">{message}</p>
        {actionLabel && onAction && (
          <button
            className="error-toast__action"
            onClick={onAction}
            type="button"
          >
            {actionLabel}
          </button>
        )}
      </div>
      <button
        className="error-toast__close"
        onClick={onClose}
        aria-label="Close notification"
        type="button"
      >
        ×
      </button>
    </div>
  );
};
